import Axios from "../extras/Axios";
import {
  PRODUCT_ROUTE,
  AGREGAR_PRODUCTO_EN_MASA,
  ENVIAR_IMAGEN,
  PUBLICAR_PRODUCTOS_EN_MASA,
  PRODUCT_ROUTE_SINGLE_ITEM,
  CAMBIAR_PRECIO_EN_MASA,
  OBTENER_PRODUCTOS_POR_ID,
  MARCAS,
  PRODUCT_ROUTE_HOME,
  RUBROS,
} from "../constants/index";

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;

const retryRequest = async (requestFn, retries = MAX_RETRIES) => {
  try {
    return await requestFn();
  } catch (error) {
    if (retries > 0 && (error.response?.status === 429 || error.response?.status >= 500)) {
      await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
      return retryRequest(requestFn, retries - 1);
    }
    throw error;
  }
};

export async function obtenerProductos(params) {
  try {
    const { data } = await retryRequest(() => 
      Axios.get(PRODUCT_ROUTE, { 
        params: { ...params },
        timeout: 10000 // 10 second timeout
      })
    );

    if (!data) {
      throw new Error('No se recibió respuesta del servidor');
    }

    if (data.length === 0) {
      return {
        productos: [],
        totalRows: 0,
        message: "No hay productos para mostrar"
      };
    }

    return data;
  } catch (error) {
    let errorMessage = "Se produjo un error en el servidor";
    let errorType = "error";

    if (error.response) {
      switch (error.response.status) {
        case 404:
          errorMessage = "No se encontraron productos";
          errorType = "warning";
          break;
        case 429:
          errorMessage = "Demasiadas solicitudes. Por favor, intente nuevamente en unos momentos";
          errorType = "warning";
          break;
        case 500:
          errorMessage = "Error interno del servidor";
          errorType = "error";
          break;
        default:
          errorMessage = `Error del servidor: ${error.response.status}`;
          errorType = "error";
      }
    } else if (error.request) {
      errorMessage = "No se pudo conectar con el servidor";
      errorType = "error";
    }

    return Promise.reject({
      mensaje: errorMessage,
      tipo: errorType,
      error: error
    });
  }
}

export async function obtenerProductosParaElHome() {
  try {
    const { data } = await Axios.get(PRODUCT_ROUTE_HOME);
    if (data.length === 0) {
      return Promise.reject({
        mensaje: "No hay productos para mostar",
        tipo: "warning",
      });
    }
    return data;
  } catch (error) {
    return Promise.reject({
      mensaje: "Se produjo un error en el servidor",
      tipo: "error",
    });
  }
}

export async function obtenerListadoProductosEnStock() {
  const respuesta = await Axios.get(PRODUCT_ROUTE, { params: { estado: 'STOCK', display: 0, page: 1 } });
  if (respuesta.status !== 200) return null;
  const listadoProductosEnStock = await respuesta.data;
  return listadoProductosEnStock.productos;
}

export async function obtenerListadoProductosParaDevolucion() {
  const respuesta = await Axios.get(PRODUCT_ROUTE, { params: { estado: 'VENDIDO', display: 0, page: 1 } });
  if (respuesta.status !== 200) return null;
  const listadoProductosParaDevolucion = await respuesta.data;
  return listadoProductosParaDevolucion.productos;
}

export async function getById(_id) {
  const producto = await (await Axios.get(PRODUCT_ROUTE_SINGLE_ITEM, { params: { _id } })).data;
  return producto;
}

export async function agregarProducto(producto) {
  const response = await Axios.post(PRODUCT_ROUTE, producto);
  const _id = response.data;
  if (response.status !== 201) return null;
  return _id;
}

export async function deleteProducto(_id) {
  const result = await Axios.delete(PRODUCT_ROUTE, { data: { _id } });
  if (result.status === 200) return true;
  return false;
}

export async function modificarProducto(producto) {
  const response = await Axios.put(PRODUCT_ROUTE, producto, { validateStatus: (status) => status < 500 });
  return response.status;
}

export async function agregarEnMasa(aceptados, rechazados, destinatario) {
  const response = await Axios.post(AGREGAR_PRODUCTO_EN_MASA, {
    aceptados,
    rechazados,
    destinatario,
  });

  if (response.status === 201) return true;
  return false;
}

export async function submitImagen(formData) {
  const respuesta = await Axios.post(ENVIAR_IMAGEN, formData, {
    Headers: { "Content-Type": "multipart/form-data" },
    validateStatus: (status) => status < 500
  });
  if (respuesta.status === 200) return true;
  return false
}

export async function publicarEnMasa(idsDeProductos) {
  const respuesta = await Axios.put(PUBLICAR_PRODUCTOS_EN_MASA, idsDeProductos);
  if (respuesta.status === 200) return true;
  return false;

}

export async function cambiarPrecioEnMasa(ids, opType, porcentaje) {
  const respuesta = await Axios.put(CAMBIAR_PRECIO_EN_MASA, {
    ids,
    opType,
    porcentaje,
  });
  if (respuesta.status === 200) return true;
  return false;
}

export async function obtenerProductosPorIds(ids) {
  const productos = await (await Axios.post(OBTENER_PRODUCTOS_POR_ID, ids)).data;
  if (productos.length > 0) return productos;
  return [];
}

export async function obtenerMarcasParaSelector() {
  return (await Axios.get(MARCAS)).data;
}


export async function obtenerRubrosParaSelector() {
  return (await Axios.get(RUBROS)).data;
}